<template>
  <div id="nfc-app-container" class="h-screen">
    <!-- Loading state shown during SSR and initial hydration -->
    <div v-if="!mounted" class="loading-container">
      <svg
        class="loading-spinner animate-spin text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        />
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
    </div>
    <!-- NFC Vue app will be mounted here by the plugin -->
  </div>
</template>

<script setup lang="ts">
const mounted = ref(false);

onMounted(() => {
  // Signal that we're ready for the NFC app to mount
  mounted.value = true;
});

// Provide the current route to the NFC app
const route = useRoute();
provide('initialRoute', route.path);
</script>

<style scoped>
.loading-container {
  height: 100vh;
  margin: auto;
  display: flex;
}

.loading-spinner {
  width: 64px;
  height: 64px;
  margin: auto;
}
</style>
